<script setup>
const props = defineProps({
    dropdownOpen: Boolean,
});
</script>

<template>
    <div
        x-show="open"
        x-transition:enter="transition ease-out duration-100"
        x-transition:enter-start="transform opacity-0 scale-95"
        x-transition:enter-end="transform opacity-100 scale-100"
        x-transition:leave="transition ease-in duration-75"
        x-transition:leave-start="transform opacity-100 scale-100"
        x-transition:leave-end="transform opacity-0 scale-95"
        class="left-0 w-full origin-top-right top-8 xl:mt-2 xl:absolute"
    >
        <slot> </slot>
    </div>
</template>
